import { atom } from "recoil"

export const inquiryUserDeviceState = atom<string | undefined>({
  key: "atoms/settings/inquiryUserDeviceState",
  default: undefined,
})
